<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>Finish Aluminum</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text class="mt-5">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-text-field
                        v-model="item.name"
                        hide-details
                        prepend-icon="mdi-form-textbox"
                        label="Name *"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="6" xl="6" lg="6" md="6">
                    <v-autocomplete
                        v-model="item.type"
                        hide-details
                        prepend-icon="mdi-format-list-bulleted-type"
                        label="Type *"
                        :items="['Woodgrain', 'Duranar 2605', 'Durastar 2604']"
                        type="string"
                        :rules="[rules.required]"
                        required
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="6" class="mt-2">
                    <v-text-field
                        v-model="item.leadTime"
                        hide-details
                        prepend-icon="mdi-calendar-clock"
                        label="Lead Time *"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="saveProcess"
                rounded
                :loading="loading"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import { objDiff } from '@/helpers/objDiff.js'
import API from '@/services/api'

export default {
    name: 'FinishForm',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        setting: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        rules: {
            required: v => !!v || 'required value',
            number: v => v > 0 || 'invalid number',
        },
    }),
    computed: {
        itemDiff: function() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveProcess() {
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        async create() {
            try {
                this.loading = true
                const item = await API.createFinishAluminum({
                    settingId: this.setting.id,
                    ...this.item,
                })
                this.$emit('addItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const item = await API.updateFinishAluminum({
                    settingId: this.setting.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
